/* eslint-disable max-len */
import { ERRORS } from '../constants';

export default {
  ERRORS: {
    [ERRORS.INVALID_PROZIS_POINTS]:
      'Ups, die ProzisPoints, die du mit dem Kurier teilen wolltest, sind nicht mehr verfügbar. Versuche es erneut.'
  },
  MESSAGES: {
    ANSWERED_SURVEY:
      'Wir haben bereits dein Feedback zur Lieferung der {code} Bestellung erhalten. \n\rWir freuen uns jedoch darauf, von deinen zukünftigen Erfahrungen zu erfahren. 👍',
    AVAILABLE_POINTS: 'Verfügbare ProzisPoints:',
    DO_NOT_SHARE_YOUR_POINTS: 'Kein Trinkgeld geben',
    EXPERIENCE_EVALUATION: 'BEWERTE DEINE LIEFERERFAHRUNG',
    FEEDBACK_HERE: 'Hinterlasse dein Feedback hier',
    FEEDBACK_THANKS:
      'Vielen Dank für dein Feedback zum Lieferservice von PROZIS NOW. \n\rWir werden daran arbeiten! 💪',
    HOW_BE_BETTER:
      'Sag uns, was wir richtig machen und was wir noch verbessern können',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    SAY_HELP_TO_COURIER: 'Möchtest du dem Kurier danken?',
    SAY_HELP_TO_USER:
      'Möchtest du dich bei demjenigen bedanken, der dir die Bestellung geliefert hat?',
    SHARE_YOUR_POINTS:
      'Teile deine ProzisPoints mit {name}. Dein Trinkgeld wird sehr geschätzt. 😉',
    TIP_COURIER: '{name} ein Trinkgeld geben',
    TIP_USER: 'Hinterlasse ein Trinkgeld für {name}'
  }
};
